import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68ACE_W } from './mg68_ace_w'

export class Mg68ACE_W_24G extends Mg68ACE_W {
  name: string = 'MG68_ACE_W'
  icon: string = list_icon
  width: number = 710
}
